export const BNK_STMT_flushUploadResponsesReducer = {
  BNK_STMT_flushUploadResponses: (state, action) => {
    state.s3FileUploadAPICall.uploadFileResponses = [null, null, null, null];
    state.screenConstHistory = [];
  },
};
